export default __webpack_public_path__ + "static/media/portfolio.24bb8c38.png";